export const selectRoleData = (state) =>state.role.roleData;